import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setDistRequestName,
  addDistToQueue,
  checkUnsavedChanges,
  resetDestRequest,
  distributeCampaign,
} from '../../../../actions/deActions/deDistributeActions';
import IconPlus from '../../shared/icons/IconPlus';
import {
  STATUS_LIST,
  END_DATE_DISABLED_STATUS,
} from '../../shared/DEConstants';

const RequestName = () => {
  const dispatch = useDispatch();
  const [isEditable, setIsEditable] = useState(false);
  const distRequest = useSelector(state => state.deDistribute.distRequest);
  const distErrors = useSelector(state => state.deDistribute.distErrors);
  const impersonated = useSelector(state => state.login.loginResponse.data.impersonated);
  const [value, onInputChange] = useState(distRequest.name);
  const inputRef = useRef();

  useEffect(() => {
    if (inputRef.current && distErrors.isNameErrMsg) {
      inputRef.current.focus();
    }
  }, [distErrors.isNameErrMsg]);

  useEffect(() => {
    onInputChange(distRequest.name);
  }, [distRequest.name]);

  useEffect(() => {
    if (inputRef.current && distErrors.isNameErrMsg) {
      inputRef.current.focus();
    }
  }, [distErrors.isNameErrMsg]);

  useEffect(() => {
    if (isEditable) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditable]);

  let isAddBtnDisabled = true;

  if (!distRequest.status || (distRequest.status === STATUS_LIST[0]
    && dispatch(checkUnsavedChanges(true)))) {
    isAddBtnDisabled = false;
  }

  const _handleAddClick = () => {
    const hasUnsavedChanges = dispatch(checkUnsavedChanges());
    if (!hasUnsavedChanges) {
      dispatch(resetDestRequest());
    }
  };

  const _handleAddToQueueClick = () => {
    dispatch(addDistToQueue());
  };

  const _handleDistributeClick = () => {
    dispatch(distributeCampaign(true));
  };

  const _handleRequestNameChange = e => {
    onInputChange(e.target.value);
  };

  const _handleRequestNameBlur = () => {
    setIsEditable(false);
    dispatch(setDistRequestName(value.trim()));
  };

  let isRequestNameDisabled = true;
  if (!distRequest.status || (distRequest.status === STATUS_LIST[0])) {
    isRequestNameDisabled = false;
  }

  const handleDoubleClick = () => {
    if (!isRequestNameDisabled) {
      setIsEditable(true);
    }
  };

  let isDistributeEnabled = false;
  const isEdited = dispatch(checkUnsavedChanges(true));
  if (END_DATE_DISABLED_STATUS.includes(distRequest.status)) {
    isDistributeEnabled = true;
  }
  if (!isEdited) {
    isDistributeEnabled = true;
  }
  if (distRequest.status === '' || distRequest.status === "Draft") {
    isDistributeEnabled = false;
  }
  
  let inputClass = 'distro__requestname-input distro__requestname-label';
  if (isRequestNameDisabled) {
    inputClass += ' distro__requestname-label--disabled';
  }

  const isNewButtonDisabled =
    !distRequest.name && !distRequest.startDate && !distRequest.endDate && !distRequest.dest.length > 0;
  
  if(impersonated){
    isRequestNameDisabled = true;
    isAddBtnDisabled = true;
    isDistributeEnabled = true;
  }

  let newButtonClass = 'de--icon--btn';
  if (isNewButtonDisabled) {
    newButtonClass += ' de--icon--btn--disabled';
  }

  let addButtonClass = 'de--btn de--btn--outline__secondary';
  if (isAddBtnDisabled) {
    addButtonClass += ' de--btn--disabled';
  }

  let distroButtonClass = 'de--btn de--btn__secondary';
  if (isDistributeEnabled) {
    distroButtonClass += ' de--btn--disabled';
  }


  return (
    <div className="distro__row distro__rn">
      <div className="distro__rn--text-box">
        {isEditable || !distRequest.name ? (
          <input
            type="text"
            value={value}
            ref={inputRef}
            id="distroRequestName"
            onChange={_handleRequestNameChange}
            onBlur={_handleRequestNameBlur}
            placeholder="Enter Request Name"
            className="distro__requestname-input"
            autoComplete="off"
            maxLength={400}
          />
        ) : (
          <div
            className={inputClass}
            onDoubleClick={() => handleDoubleClick()}
            title={distRequest.name}
          >
            <div className="LinesEllipsis">{distRequest.name}</div>
          </div>
        )}
        
      </div>

      {distErrors.isNameErr && (
        <div className="distro__rn--error">{distErrors.isNameErrMsg}</div>
      )}

      <div className="distro__rn--actions">
        <button
          type="button"
          onClick={() => _handleAddClick()}
          className={newButtonClass}
          disabled={isNewButtonDisabled}
        >
          <IconPlus
            color={
              isNewButtonDisabled
                ? '#cccccc'
                : '#4e0e28'
            }
          />
        </button>
        <button
          type="button"
          onClick={() => _handleAddToQueueClick()}
          className={addButtonClass}
          disabled={isAddBtnDisabled}
        >
          <span>Add to Queue</span>
        </button>
        <button
          type="button"
          onClick={() => _handleDistributeClick()}
          className={distroButtonClass}
          disabled={isDistributeEnabled}
        >
          <span>Submit</span>
        </button>
      </div>
    </div>
  );
};

export default RequestName;
